import { Alert, Space, Tag } from "antd";
import { useDispatch } from "react-redux";
import { showDeleteConfirm } from "../../helpers/confirmModal";
import { DefaultTag, EnviadoTag, ErrorTag, MoreOptionsColumn } from "../ui";
import { TableSearchBasicUi } from "../ui/TableSearchBasicUi";
import {
  notificacionSetActive,
  notificacionStartDelete,
} from "../../actions/notificacion";
import { EstadoNotificacionConstants, messageError } from "../../helpers";
import { DeleteOutlined, EditOutlined, SendOutlined } from "@ant-design/icons";
import { useNotificaciones } from "../../hooks";

const keysMenuActions = {
  btn_editar: {
    key: "btn_editar",
    label: "Editar",
    icon: <EditOutlined />,
  },
  btn_eliminar: {
    key: "btn_eliminar",
    label: "Eliminar",
    icon: <DeleteOutlined />,
  },
  btn_enviar: {
    key: "btn_enviar",
    label: "Enviar",
    icon: <SendOutlined />,
  },
};
const menuItems = (data) => [
  { ...keysMenuActions.btn_editar },
  { ...keysMenuActions.btn_eliminar },
  { ...keysMenuActions.btn_enviar },
];

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Mensaje",
    dataIndex: "mensaje",
    key: "mensaje",
    render: (text, record, index) => (
      <Alert message={text} type={record?.tipo || ""} showIcon />
    ),
  },
  {
    title: "App referencia",
    dataIndex: "app",
    key: "app",
    align: "center",
  },
  {
    title: "Canal",
    dataIndex: "canalnombre",
    key: "canalnombre",
    align: "center",
  },
  {
    title: "Fec.Envió",
    dataIndex: "fechaenvio",
    key: "fechaenvio",
  },
  {
    title: "Estado",
    dataIndex: "estadonombre",
    key: "estadonombre",
    align: "center",
    render: (text, record) => {
      if (record?.estado === EstadoNotificacionConstants.PENDIENTE) {
        return <DefaultTag text={text} />;
      } else if (record?.estado === EstadoNotificacionConstants.ENVIADA)
        return <EnviadoTag />;
      else if (record?.estado === EstadoNotificacionConstants.FALLIDA)
        return <ErrorTag text={text} />;
    },
  },
  {
    title: "¿Ha sido leido?",
    dataIndex: "leido",
    key: "leido",
    align: "center",
    render: (text, record) =>
      text === true ? <Tag color="green">Si</Tag> : <Tag color="red">No</Tag>,
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    align: "center",
    render: (text, record) => (
      <MoreOptionsColumn
        data={record}
        MenuItems={menuItems}
        handleMenuItemClick={acciones?.handleMenuItemClick}
      />
    ),
  },
];
export const NotificacionesTable = ({ data, loading, onOpenModal }) => {
  const { sendNotificacion } = useNotificaciones();
  const dispatch = useDispatch();
  const handleEditar = (data) => {
    dispatch(notificacionSetActive(data));
    onOpenModal();
  };
  const handleEliminar = (item) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar la notificación seleccionada?",
      `${item.mensaje}`,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(notificacionStartDelete(item));
        }
      },
    );
  };
  const handleEnviar = (item) => {
    console.log("btn", item);
    sendNotificacion(item);
  };
  const handleMenuItemClick = (e, record) => {
    try {
      if (e.key === keysMenuActions.btn_editar.key) {
        handleEditar(record);
      } else if (e.key === keysMenuActions.btn_eliminar.key) {
        handleEliminar(record);
      } else if (e.key === keysMenuActions.btn_enviar.key) {
        handleEnviar(record);
      }
    } catch (errors) {
      messageError(errors);
    }
  };
  return (
    <TableSearchBasicUi
      columns={columns({
        handleEditar,
        handleEliminar,
        handleMenuItemClick,
      })}
      rowKey="id"
      bordered
      dataSource={data}
      loading={loading}
      size="small"
    />
  );
};
